import React, {useState} from 'react';

import PreferencesChoose from './components/preferencesChoose';
import PreferencesCompleted from './components/preferencesCompleted';

const Preferences = ({code, handleChangePreferences, hasPreferences, isCompleted}: CustomsPreferencesProps) => {
  const [ isEditing, setIsEditing ] = useState(false);

  const shouldShowChoice = !isCompleted || isEditing;

  if (shouldShowChoice) {
    return <PreferencesChoose code={code} handleChangePreferences={handleChangePreferences} />;
  }

  return (
    <PreferencesCompleted
      hasPreferences={Boolean(hasPreferences)}
      code={code}
      handleEdit={() => setIsEditing(true)}
    />
  );
};

export default Preferences;
